import { useQuery } from '@apollo/client';
import { priorPeriodRange } from '../utils/dateRange';

/** Run the same query for the selected range and the prior equal-length window. */
export default function useCurrentAndPriorQuery(query, range) {
  const priorRange = priorPeriodRange(range);
  const current = useQuery(query, { variables: { range } });
  const prior = useQuery(query, { variables: { range: priorRange } });

  return {
    data: current.data,
    priorData: prior.data,
    loading: current.loading || prior.loading,
    error: current.error || prior.error,
    refetch: () => Promise.all([current.refetch(), prior.refetch()]),
  };
}
